import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

@Pipe({
    name: 'releaseDayPipe',
    standalone: true
})
export class ReleaseDayPipe implements PipeTransform {
    transform(scheduleReleaseDate: string | Date | null | undefined): string {
        if (!scheduleReleaseDate) {
            return '';
        }

        const now = dayjs.utc().startOf('minute');
        const releaseDate = dayjs.utc(scheduleReleaseDate).startOf('minute');

        if (releaseDate.isBefore(now)) {
            return '';
        }

        const diffInMinutes = releaseDate.diff(now, 'minute');
        const diffInHours = releaseDate.diff(now, 'hour', true);

        if (diffInMinutes < 60) {
            return diffInMinutes + ' minutes';
        } else if (diffInHours < 24) {
            return Math.floor(diffInHours) + ' hours';
        } else {
            const diffInDays = Math.ceil(diffInHours / 24);

            if (diffInDays < 30) {
                return diffInDays > 1 ? `${diffInDays} days` : '1 day';
            } else {
                const diffInMonths = Math.ceil(diffInDays / 30);
                return diffInMonths > 1 ? `${diffInMonths} months` : 'a month';
            }
        }
    }
}
